import React, { useEffect, useState } from "react";
import { AssetPreview } from "./asset-preview";
import { KeyValueList } from "../atoms/key-value-list";
import { Checkbox } from "../atoms/checkbox";
import { ActionButtons } from "../atoms/action-buttons";
import { useTasks } from "../../providers/task-provider";
import { useSubmission } from "../../providers/submission-provider";
import { snakeCaseToWords } from "../../utils/common";

interface ReviewSubmissionProps {
  pictureFile: File;
  audioFile: File;
  onEdit: () => void;
  onSubmit: () => void;
}

export const ReviewSubmission: React.FC<ReviewSubmissionProps> = ({
  pictureFile,
  audioFile,
  onEdit,
  onSubmit,
}) => {
  const { submission, setSubmissionProperties } = useSubmission();
  const { currentTask } = useTasks();
  const [metadataSummary, setMetadataSummary] = useState<any[]>([]);

  useEffect(() => {
    if (submission?.submission_metadata) {
      setMetadataSummary(() =>
        Object.keys(submission.submission_metadata).map((key) => [
          snakeCaseToWords(key),
          submission.submission_metadata[key],
        ]),
      );
    }
  }, [submission]);

  return (
    <>
      <h2 className="text-left mb-2">Review & Submit</h2>
      <div className="rounded-xl border-dark-gray-1 border text-left p-4 mb-2">
        <h3 className="mb-2">Your Recording</h3>
        <AssetPreview pictureFile={pictureFile} audioFile={audioFile} />
      </div>
      <div className="rounded-xl border-dark-gray-1 border text-left p-4 mb-2">
        <h3 className="mb-2">Metadata Summary</h3>
        <KeyValueList data={metadataSummary} />
      </div>
      <Checkbox
        checked={submission?.confirm_is_original_sound}
        onChange={(value) =>
          setSubmissionProperties({ confirm_is_original_sound: value })
        }
        label="I confirm this is an original recording made by me for this project, with no post-procesing or artificial enhacement."
      />
      <br />
      <Checkbox
        checked={submission?.grant_perle_and_samsung_full_commercial_right}
        onChange={(value) =>
          setSubmissionProperties({
            grant_perle_and_samsung_full_commercial_right: value,
          })
        }
        label="I grant Perle full commercial rights to use this recording in AI model training and other applications."
      />
      <ActionButtons
        primaryText="Submit"
        secondaryText="Edit"
        onSecondaryClick={onEdit}
        onPrimaryClick={() => {
          if (
            submission?.confirm_is_original_sound &&
            submission?.grant_perle_and_samsung_full_commercial_right
          ) {
            onSubmit();
          }
        }}
      />
    </>
  );
};
